import { PROFILE_DETAILS_CONTENT_MAX_HEIGHT } from '@aibees/elephant/constants';
import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  gap: (p) => `${p.spacing(1.5)} !important`,
  display: 'flex',
  flexDirection: 'column',
};

export const lastUpdate: SxStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'row',
  px: (p) => p.spacing(1),
  py: 0,
  gap: (p) => p.spacing(0.25),
};

export const configContent: SxStyle = {
  padding: (p) => p.spacing(0, 1, 1, 1),
};

export const generalProfileDetailsScrollbar: SxStyle = {
  maxHeight: (p) => p.spacing(PROFILE_DETAILS_CONTENT_MAX_HEIGHT),
};
